import { useSelector } from 'react-redux'
import { useCurrentJackpotUserSpecific } from '@hooks/queries/useJackpot'

// Ports defenderV2's JACKPOT_POLL_INTERVAL (10s) — TanStack's own
// `refetchInterval` does the polling natively, no manual setInterval needed.
const POLL_INTERVAL_MS = 10000

// The ONE shared "is there an active jackpot right now" source. The header
// bar, the main-layout ratio message (Index.jsx), and the menu's Active tab
// all read from this single polled query (same queryKey -> same TanStack
// cache entry, so they share ONE network poll, not one each).
export const useActiveJackpot = () => {
  const jackpotEnabled = useSelector((state) => state.configurations.featureToggles.jackpot)

  const { data, isPending, isError } = useCurrentJackpotUserSpecific(
    {},
    { enabled: jackpotEnabled, refetchInterval: jackpotEnabled ? POLL_INTERVAL_MS : false }
  )

  return {
    jackpotEnabled,
    jackpot: data ?? null,
    isActive: jackpotEnabled && Boolean(data),
    isPending,
    isError,
  }
}
